import { useState } from "react";
import {
  Box,
  Chip,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  OutlinedInput,
  Select,
  Stack,
  ToggleButton,
  ToggleButtonGroup,
} from "@mui/material";
import { Theme, useTheme } from "@mui/material/styles";
import { useDispatch } from "react-redux";
import { LAYOUT_MARGIN } from "Configs/home";
import { useParams } from "react-router-dom";

import { changeSysCode, changeCompanyCode } from "Redux/reportSlice";
import { useAppSelector } from "Hooks/useRedux";
import KeyboardDoubleArrowRightIcon from "@mui/icons-material/KeyboardDoubleArrowRight";
import btnImage from "Assets/Images/ic--round-double-arrow.svg";
import { REPORT_DATA } from "./reportData";

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

function getStyles(name: string, systems: readonly string[], theme: Theme) {
  return {
    fontWeight: systems.includes(name) ? theme.typography.fontWeightMedium : theme.typography.fontWeightRegular,
  };
}

export default function SingleReport() {
  const theme = useTheme();
  const dispatch = useDispatch();
  const { reportValue } = useParams();
  const { systems, companies } = useAppSelector((state) => state.report);
  const [sideMode, setSideMode] = useState<boolean>(false);

  console.log(reportValue, "vdsvhntfhb");
  const reportNumber = Number(reportValue?.split("_")[0]);
  const subReportNumber = Number(reportValue?.split("_")[1]);

  const allSystems = [
    "طرح کنترل الودگی",
    "طرح ترافیک",
    "ثبت تخلف سرعت",
    "ثبت تخلف چراغ قرمز",
    "پلاک خوان مسیر ویژه اتوبوس",
    "پلاک خوان لاین اضطرار",
    "پلاک خوان رینگ تهران",
    "پلاک خوان خودرو سنگین",
    "پلاک خوان تره بار",
    "پلاک خوان تاکسیرانی",
    "پلاک خوان بهشت زهرا",
  ];

  const allCompanies = ["مگفا", "گصن", "داتیس"];

  const handleChangeSystem = (event: any) => {
    const {
      target: { value },
    } = event;
    dispatch(changeSysCode(typeof value === "string" ? value.split(",") : value));
  };

  const handleChangeCompany = (event: any) => {
    const {
      target: { value },
    } = event;
    dispatch(changeCompanyCode(typeof value === "string" ? value.split(",") : value));
  };

  const urlCreator = () => {
    if (reportNumber === 6 && subReportNumber === 1) {
      const systemParams = systems.map((s) => {
        return { $type: "WebParameterValue", Id: s, Value: s };
      });

      const companyParams = companies.map((c) => {
        return { $type: "WebParameterValue", Id: c, Value: c };
      });

      return `https://report.baarestan.ir:8080/dashboard/publicview?dashboardid=25c862a7-9341-454d-b113-10c77f41d1c6&paramvalues={"a9a44bc5-249d-abd1-278e-5ab194462f4f":[{"Value":${JSON.stringify(
        systemParams
      )},"FromColumn":false,"SelectedField":null}],"fb4e0910-b7e2-f5d7-c34e-24c82476d766":[{"Value":${JSON.stringify(
        companyParams
      )},"FromColumn":false,"SelectedField":null}]}`;
    }
    return REPORT_DATA[reportNumber - 1]?.items[subReportNumber - 1]?.url;
  };

  const fSx = {
    m: sideMode ? 0 : 1,
    width: sideMode ? "0px" : "300px",
    opacity: sideMode ? "0" : "1",
    transition: "all 0.3s ease-in-out",
  };

  return (
    <>
      <Grid container sx={{ direction: "ltr", height: "100vh" }}>
        <Grid
          item
          md={!sideMode && reportNumber === 6 && subReportNumber === 1 ? 2.5 : 0}
          sx={{
            backgroundColor: "#f1f1f1",
            padding: sideMode ? "0" : "20px",
            position: "relative",
            display: reportNumber === 6 && subReportNumber === 1 ? "block" : "none",
          }}
        >
          <FormControl sx={fSx}>
            <InputLabel id="single-report-select-system">سیستم</InputLabel>
            <Select
              sx={{ transition: "all 0.3s ease-in-out", width: sideMode ? "0" : "90%" }}
              labelId="single-report-select-system"
              id="multiple-chip-system"
              multiple
              value={systems}
              onChange={handleChangeSystem}
              input={<OutlinedInput id="select-multiple-chip-system" label="Chip" />}
              renderValue={(selected) => (
                <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}>
                  {selected.map((value) => (
                    <Chip key={value} label={value} />
                  ))}
                </Box>
              )}
              MenuProps={MenuProps}
            >
              {allSystems.map((s) => (
                <MenuItem key={s} value={s} style={getStyles(s, systems, theme)}>
                  {s}
                </MenuItem>
              ))}
            </Select>
          </FormControl>

          <FormControl sx={fSx} style={{ marginTop: "100px" }}>
            <InputLabel id="single-report-select-company">شرکت ها</InputLabel>
            <Select
              sx={{ transition: "all 0.3s ease-in-out", width: sideMode ? "0" : "90%" }}
              labelId="single-report-select-company"
              id="multiple-chip-company"
              multiple
              value={companies}
              onChange={handleChangeCompany}
              input={<OutlinedInput id="select-multiple-chip-company" label="Chip" />}
              renderValue={(selected) => (
                <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}>
                  {selected.map((value) => (
                    <Chip key={value} label={value} />
                  ))}
                </Box>
              )}
              MenuProps={MenuProps}
            >
              {allCompanies.map((c) => (
                <MenuItem key={c} value={c} style={getStyles(c, companies, theme)}>
                  {c}
                </MenuItem>
              ))}
            </Select>
          </FormControl>

          <button
            type="button"
            onClick={() => setSideMode(!sideMode)}
            style={{
              position: "absolute",
              left: "-30px",
              top: "45%",
              border: "1px solid  rgb(211 208 208)",
              width: "50px",
              height: "50px",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              borderRadius: "50%",
              cursor: "pointer",
              transform: sideMode ? "rotate(180deg)" : "rotate(0deg)",
              transition: "all 0.3s ease-in-out",
            }}
          >
            <img src={btnImage} alt="arrow-btn" style={{ width: "34px" }} />
          </button>
        </Grid>
        <Grid item md={!sideMode && reportNumber === 6 && subReportNumber === 1 ? 9.5 : 12}>
          <iframe
            src={urlCreator()}
            title="star-dashboard"
            style={{
              width: "100%",
              transition: "all 0.3s",
              border: "none",
              height: "100vh",
            }}
            onError={() => {}}
          />
        </Grid>
      </Grid>
    </>
  );
}
